import { initializeApp } from 'firebase/app';
import getAuth, { connectAuthEmulator } from '@/utils/auth';
import getDebuggerHost from './getDebuggerHost';

const fbConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
};

let isEmulatorConnected = false;

export default function connectToFirebase(emulate = false) {
  const app = initializeApp(fbConfig);
  const auth = getAuth(app);

  if (emulate && !isEmulatorConnected) {
    const host = `http://${getDebuggerHost()}:${
      process.env.EXPO_PUBLIC_FIREBASE_AUTH_EMULATOR_PORT || 9099
    }`;

    connectAuthEmulator(auth, host, {
      disableWarnings: true,
    });
    isEmulatorConnected = true;
  }

  const firebase = { app, auth };
  return firebase;
}
